import React, { useEffect, useState } from 'react';

const DESKTOP_QUERY = '(min-width: 1024px)';

/** Matches Tailwind `lg`. Used so mobile and desktop each mount one set of header actions. */
export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(DESKTOP_QUERY).matches : false
  );

  useEffect(() => {
    const media = window.matchMedia(DESKTOP_QUERY);
    const onChange = () => setIsDesktop(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}

/**
 * Full-width mobile header. Content scrolls underneath the solid bar
 * instead of showing through the gaps between the buttons.
 */
export function MobileActionBar({ menuOpen, onOpenMenu, children }) {
  const isDesktop = useIsDesktop();
  if (isDesktop) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-40 flex h-14 items-center gap-2 border-b border-gray-800 bg-black px-3">
      <button
        type="button"
        onClick={onOpenMenu}
        className="inline-flex h-9 shrink-0 items-center gap-1.5 rounded-md border border-gray-700 bg-gray-950 px-2.5 text-sm font-medium text-gray-200"
        aria-label="Open navigation"
        aria-expanded={menuOpen}
      >
        <span aria-hidden="true">☰</span>
        Menu
      </button>
      {children ? (
        <div className="ml-auto flex min-w-0 items-center justify-end gap-1.5">{children}</div>
      ) : null}
    </div>
  );
}
